import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { PmsProduct } from '../../interfaces/pms-product.interface';

export interface ProductsState {
  products: PmsProduct[];
  productsLoading: boolean;
}

export const initialState: ProductsState = {
  products: [],
  productsLoading: false,
};

const productsReducer = createReducer(
  initialState,
  on(actions.GetProducts, (state, payload) => ({
    ...state,
    productsLoading: true,
  })),
  on(actions.GetProductsFail, (state, payload) => ({
    ...state,
    productsLoading: false,
  })),
  on(actions.GetProductsSuccess, (state, payload) => ({
    ...state,
    products: payload.products,
    productsLoading: false,
  })),
);

export function reducer(state: ProductsState | undefined, action: Action): ProductsState {
  return productsReducer(state, action);
}
